import { html, type TemplateResult } from "lit";
import { AsyncDirective, directive, type PartInfo } from "lit/async-directive.js";

class FeatureFlag extends AsyncDirective {
  constructor(partInfo: PartInfo) {
    super(partInfo);
  }

  override reconnected(): void {}
  override disconnected(): void {}

  render(condition: boolean | (() => boolean), innerContent: TemplateResult, reason?: string) {
    let isOn = false;
    if (typeof condition === "boolean") {
      isOn = condition;
    } else {
      isOn = condition();
      reason ??= condition.name;
    }

    if (isOn) return innerContent;
    return html`<div style="display: none;">This feature is disabled ${reason ? `reason: ${reason}` : ""}</div>`;
  }
}

export const featureFlag = directive(FeatureFlag);
